/** Direct APK file URL (tracking uses query param on this host). */
export const APK_FILE_URL =
  process.env.REACT_APP_APK_DOWNLOAD_URL ||
  'https://nvoisyshealth.com/download';

export const BUSINESS_TRACKING_PARAM =
  process.env.REACT_APP_APK_TRACKING_PARAM || 'business';

/** Center icon for generated partner QR codes (same-origin; remote URLs need CORS). */
export const QR_BRAND_ICON =
  process.env.REACT_APP_QR_BRAND_ICON ||
  `${process.env.PUBLIC_URL || ''}/qr_logo.png`;

export function slugifyBusinessName(name) {
  return String(name ?? '')
    .trim()
    .toLowerCase()
    .replace(/['"]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

/** Display label with an uppercase first character. */
export function formatBusinessDisplayName(name) {
  const label = String(name ?? '').trim();
  if (!label) return label;
  return label.charAt(0).toUpperCase() + label.slice(1);
}

/**
 * Build a business-attributed APK download URL for QR encoding.
 * Query value keeps spaces from the entered name (encoded as %20).
 */
export function buildBusinessApkDownloadUrl(businessName) {
  const label = String(businessName ?? '').trim();
  const slug = slugifyBusinessName(label);
  if (!label) {
    return { businessName: '', businessSlug: '', url: '' };
  }
  const url = new URL(APK_FILE_URL);
  url.searchParams.set(BUSINESS_TRACKING_PARAM, label);
  return {
    businessName: label,
    businessSlug: slug,
    url: url.toString()
  };
}

/** Map `bussiness_QRs` collection record → UI row. */
export function mapBusinessQrRecord(record) {
  const businessName = String(record?.name ?? '').trim();
  const { businessSlug, url } = buildBusinessApkDownloadUrl(businessName);
  return {
    id: record?.id,
    businessName,
    businessSlug,
    url,
    downloadCount: Number(record?.count ?? 0),
    createdAt: record?.created,
    updatedAt: record?.updated
  };
}
